import { createContext, useContext, useState, type ReactNode } from 'react'
import { clsx } from 'clsx'
import $ from './styles.css'

type Toast = {
  id: number
  message: string | ReactNode
  className?: string
  hiding?: boolean
}

const ToastContext = createContext<(message: string | ReactNode, className?: string) => void>(() => {})

export function useToast() {
  return useContext(ToastContext)
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([])

  function show(message: string | ReactNode, className?: string) {
    const id = Date.now()
    setToasts(prev => [...prev, { id, message, className }])
    setTimeout(() => {
      setToasts(prev => prev.map(t => t.id === id ? { ...t, hiding: true } : t))
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id))
      }, 200)
    }, 5000)
  }

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div class={$.container}>
        {toasts.map(toast => (
          <div key={toast.id} class={clsx($.toast, toast.hiding && $.hiding, toast.className)}>
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}
